export class SelectionsModel {
    indicationName: string;
    controlName: string;
    controlType: ControlTypeEnum;
    controlDisplayName: string;
    selectionValue: any;
    selectionDisplayName: string;
    order: number;
}


export enum ControlTypeEnum {
  TEXT = 0,
  RADIO = 1,
  RADIO_WITH_CHECKBOX = 2,
  CHECKBOX = 3,
  DROPDOWN = 4,
  MULTISELECT = 5,
  RANGE_SLIDER = 6,
  CUSTOM = 7,
  IGNORE_IN_UI = 8
}

export class SelectionsErrorModel extends SelectionsModel {
  indicationGroupName: string;
  indicationGroupDisplayName: string;
  errorMessage: string;
}